import {  PENDING_YOUR_APPROVAL } from '../../../../../src/constants';

 //Function for setting list of payment status for applying filter
function getPaymentStatusList(key) {
    let arrList = [];
    if (key === PENDING_YOUR_APPROVAL.KEY) {
      arrList = [{
        key: key,
        value: PENDING_YOUR_APPROVAL.LABEL,
        label: PENDING_YOUR_APPROVAL.LABEL,
        tier: 'root',
        level: 1
      }]
      return arrList;
    }
    else {
      arrList = [{
        key: key,
        value: key,
        label: key,
        tier: 'root',
        level: 1
      }]
      return arrList
    }
  }
//WMCE-54987 -Function to get initiator array for rejected and expired payments
  function getArrayForInitiator(key , currentUserId) {
    let arrList = [];
    if (currentUserId && key !== PENDING_YOUR_APPROVAL.KEY) {
      arrList = [{
        label: currentUserId + ` (myself)`,
        value: currentUserId,
        key: currentUserId,
        tier: 'root',
        level: 1
      }]
      return arrList;
    }
  }

export {
  getPaymentStatusList,
  getArrayForInitiator
};